<template>
    <div>
      <sector-list></sector-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  